import styled from '@emotion/styled';
import { ExitSurveyIcons } from '@bbkAdminUtils/icons/funnel-icons';

export const getSvgIcon = (icon: string) => {
  const iconItem = ExitSurveyIcons[icon];
  return iconItem?.svg || null;
};

export const FunnelButtonIcon = styled.span`
  height: 24px;
  width: 24px;
  padding-left: 5px;
  padding-right: 5px;
  display: inline-flex;

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }

  path {
    fill: inherit;
  }
`;
